export default [
  {
    path: '/admin',
    name: 'auth.admin',
    component: () => import(/* webpackChunkName: "clients" */ './admin.vue'),
    meta: {
      layout: 'none',
      auth: 'guest',
    },
  },
];
